import createPermission from 'permissions/createPermission'

export const view = createPermission('remoteInspections.options.show')
export const edit = createPermission('remoteInspections.options.edit')

export default view